module.exports = __webpack_public_path__ + "img/hero_lg.ef51dc1.webp";